import * as React from 'react'
import { registerCardTemplate } from "../../../common/common";
import { lazyTemplate } from "../../lazyTemplate";
import { generateIconProp } from "../../../common/icon-selector/IconEditor";
import { FAIcon as FontAwesomeIcon } from '../../../common/components/FAIcon';
import { IPopulationPercentageWidgetProps } from './PopulationPercentageWidgetProperty';

// The presets (seed values + swatch previews) were moved out of the render
// component so metadata can register eagerly while the render code (XPR)
// code-splits into its own tpl-population-percentage-widget chunk. DefaultChartProperties
// is duplicated here (the render component keeps its own copy) so `seed` resolves
// without importing from the now-lazy view module.
const DefaultChartProperties: IPopulationPercentageWidgetProps = {
    refreshInterval: 60000,
    channel: '',
    firstValueField: '',
    secondValueField: '',
    secondValueConstant: '',
    icon: 'userAlt',
    iconColor: '#424242',
    label: 'Items',
    labelColor: '#424242',
    secondValueIsTotal: false,

};

interface IWidgetTheme {
    background: string;
    text: string;
}
let Themes: IWidgetTheme[] = [
    {
        background: '#8CA5BF',
        text: 'white',
    },
    {
        background: "#EBEBEB",
        text: "#424242",
    },
    {
        background: "#E8F1FE",
        text: "#424242",
    },
    {
        background: "#FAE4A9",
        text: "#424242",
    },
    {
        background: "#262626",
        text: "#FFF",
    },
    {
        background: "#EFECE9",
        text: "#424242",
    },
    {
        background: "#E4EDD9",
        text: "#424242",
    },
    {
        background: "#1B457B",
        text: "#FFF",
    },
    {
        background: "#F7D0BF",
        text: "#424242",
    },
];
// v4's theme picker seeded chartProperty/title with these defaults before
// writing the colors — `seed` reproduces that (applied only when absent). The
// swatch is the v4 mini preview: person icons on the theme background.
const Presets = Themes.map((t, i) => ({
    id: `theme-${i}`,
    name: `Theme ${i + 1}`,
    seed: {
        chartProperty: DefaultChartProperties,
        title: { text: '', color: '', size: '14px' },
    },
    uiProps: {
        chartProperty: { labelColor: t.text, iconColor: t.text },
        headerContainer: { background: { color: t.background } },
        title: { color: t.text },
    },
    renderSwatch: () => (
        <div
            style={{
                width: '100%',
                height: '100%',
                display: 'flex',
                flexWrap: 'wrap',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '0.3333rem',
                background: t.background,
            }}
        >
            <FontAwesomeIcon style={{ width: '1rem', height: '1rem', color: t.text }} icon={generateIconProp('userAlt')} />
            <FontAwesomeIcon style={{ width: '1rem', height: '1rem', color: t.text }} icon={generateIconProp('userAlt')} />
            <FontAwesomeIcon style={{ opacity: 0.5, width: '1rem', height: '1rem', color: t.text }} icon={generateIconProp('userAlt')} />
        </div>
    ),
}));

registerCardTemplate({
    id: 'population-percentage-widget',
    name: 'Population Percentage Widget',
    description: 'This widget visualizes how many items out of a total are valid/invalid with a visual depiction of quantities',
    template: lazyTemplate(() => import(/* webpackChunkName: "tpl-population-percentage-widget" */ "./PopulationPercentageWidgetTemplate")),
    presets: Presets,
    icon: generateIconProp('braille'),
    complexity: 'easy',
    preLoader: 'donut-chart',
    expectedSchema: 'dictionary'
});
